import React from "react";
import { Grid, FormControl, InputLabel, Select, MenuItem, Typography, TextField } from "@mui/material";
import { Field, useFormikContext } from "formik";
import { STATUS_OPTIONS, SHELVED_OPTIONS } from "../../../services/formConfig";

const OrderStatusForm = () => {
  const { values, handleChange, touched, errors, setFieldValue } = useFormikContext();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <FormControl fullWidth margin="normal">
          <InputLabel id="status-label">Status</InputLabel>
          <Select
            labelId="status-label"
            name="status"
            value={values.status}
            label="Status"
            onChange={handleChange}
          >
            {STATUS_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
          {touched.status && errors.status && (
            <Typography color="error" variant="body2">
              {errors.status}
            </Typography>
          )}
        </FormControl>
      </Grid>
      <Grid item xs={12} md={4}>
        <FormControl fullWidth margin="normal">
          <InputLabel id="shelved-label">Arquivado</InputLabel>
          <Select
            labelId="shelved-label"
            name="shelved"
            value={values.shelved ? "true" : "false"}
            label="Arquivado"
            onChange={(e) => setFieldValue("shelved", e.target.value === "true")}
          >
            {SHELVED_OPTIONS.map((option) => (
              <MenuItem key={option.value.toString()} value={option.value ? "true" : "false"}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={4}>
        <Field
          as={TextField}
          name="designId"
          label="ID do Design"
          fullWidth
          margin="normal"
          error={touched.designId && Boolean(errors.designId)}
          helperText={touched.designId && errors.designId}
        />
      </Grid>
    </Grid>
  );
};

export default OrderStatusForm;